import Styles from './styles.module.css';
import SectionTitle from '../../home/_ui/sectionTitle';
import { IoAddOutline } from 'react-icons/io5';

/*
 * answer が null の項目は、コードベース・既存資料から確定できないため未記載。
 * TODO: 学校運用・契約条件の確定情報を受領してから answer を埋める。
 */
const FAQ: { q: string; a: string | null }[] = [
  {
    q: '今まで紙で届いていた求人票はどうなりますか？',
    a: null,
  },
  {
    q: 'PDF で届いた求人票はどう扱いますか？',
    a: null,
  },
  {
    q: 'サロンへの案内は学校側で行う必要がありますか？',
    a: 'memorii works 側からサロンへ Web での求人票提出をご案内し、利用の支援を行います。学校側から全サロンへ個別に依頼して回る必要はありません。',
  },
  {
    q: 'すべてのサロンが Web 入力に切り替わりますか？',
    a: null,
  },
  {
    q: '学生はアプリのダウンロードが必要ですか？',
    // TODO: 学生Webの提供範囲・機能差を確認のうえ確定
    a: 'アプリのほか Web でも求人を閲覧できます。',
  },
  {
    q: '過去年度の求人は管理できますか？',
    a: null,
  },
  {
    q: '導入時に学校側で必要な作業はありますか？',
    a: null,
  },
  {
    q: '費用はいくらですか？',
    // TODO: 料金体系。現状は資料・問い合わせ誘導のみ。
    a: '料金の詳細は資料でご案内しています。お問い合わせください。',
  },
  {
    q: '現在の運用と併用できますか？',
    a: null,
  },
];

const Faq = () => {
  return (
    <section id="faq" className={Styles.faq}>
      <SectionTitle pattern="B" title="よくある質問" />

      <div className={Styles.list}>
        {FAQ.map((item) => (
          <details key={item.q} className={Styles.item}>
            <summary>
              <span className={Styles.q}>{item.q}</span>
              <IoAddOutline className={Styles.mark} />
            </summary>
            {item.a ? (
              <p className={Styles.a}>{item.a}</p>
            ) : (
              <p className={`${Styles.a} ${Styles.todo}`}>
                回答内容を確認中です。（社内確認事項）
              </p>
            )}
          </details>
        ))}
      </div>
    </section>
  );
};

export default Faq;
